import { apiService } from './api.service';
import { CR_API_ENDPOINTS } from '../constants/api.constants';
import { PoiLocation, AtsBreakerSize } from '../types/api.types';

export const poiLocationsService = {
  // Get all POI locations
  async getAll(): Promise<PoiLocation[]> {
    return await apiService.get<PoiLocation[]>(CR_API_ENDPOINTS.POI_LOCATIONS);
  },

  // Get locations for a specific POI
  async getByPoiId(poiId: string): Promise<PoiLocation[]> {
    const endpoint = CR_API_ENDPOINTS.POI_LOCATIONS_BY_ID.replace(':id', poiId);
    return await apiService.get<PoiLocation[]>(endpoint);
  },

  // Get all ATS breaker sizes
  async getAllAtsBreakerSizes(): Promise<AtsBreakerSize[]> {
    return await apiService.get<AtsBreakerSize[]>(CR_API_ENDPOINTS.ATS_BREAKER_SIZES);
  },

  // Create POI location
  async createPoiLocation(poiLocationData: {
    poi_id: string;
    location_name: string;
  }): Promise<PoiLocation> {
    return await apiService.post<PoiLocation>(CR_API_ENDPOINTS.POI_LOCATIONS_CREATE, poiLocationData);
  },

  // Create ATS breaker size
  async createAtsBreakerSize(atsBreakerData: {
    amperage: number;
  }): Promise<AtsBreakerSize> {
    return await apiService.post<AtsBreakerSize>(CR_API_ENDPOINTS.ATS_BREAKER_SIZES_CREATE, atsBreakerData);
  }
};